// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Spinner_Overlay__1qYhf","CenterContainer":"Spinner_CenterContainer__39vnE","Loader":"Spinner_Loader__lxLDM","load3":"Spinner_load3__3bg6X"};